import { useContext } from 'react';

import { observer } from 'mobx-react-lite';
import { userGlobalStoreCtx } from 'src/stores/user';

export default observer(({ children }: { children: JSX.Element }) => {
  const { isAdmin } = useContext(userGlobalStoreCtx);
  return isAdmin ? children : null;
});
